import { itemName } from '../../trace/ports.js';
import { hasParentCycle } from '../../model/hierarchy.js';
import { defineRule } from '../rule.js';

/** E: an item's parent is missing or the parent chain loops back to the item. */
export const parentInvalid = defineRule(
  'parent-invalid',
  'error',
  { en: 'Invalid parent', de: 'Ungültiges Elternelement' },
  (data, emit) =>
    Object.values(data.items)
      .filter(
        (i) =>
          i.parentId !== undefined &&
          (data.items[i.parentId] === undefined || hasParentCycle(data, i)),
      )
      .map((i) => emit([i.id], { label: itemName(i) })),
);
